require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-wochenoeffnungszeiten-oeff-woche-0-3-j-2018-19.json") })
        }
      }, "path---kriterien-wochenoeffnungszeiten-oeff-woche-0-3-j-2018-19");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-wochenoeffnungszeiten-oeff-woche-0-3-j-2018-19!./.cache/json/kriterien-wochenoeffnungszeiten-oeff-woche-0-3-j-2018-19.json
// module id = 1128
// module chunks = 231608221292675